import { createSelector } from 'helpers/reselect'

export const getMyLocation = ({ selectMyLocation = {}}) => selectMyLocation
export const getMyLocationIdsFromState = state => getMyLocation(state)

export const getMyLocationIds = createSelector(
  [
    getMyLocationIdsFromState
  ],
  ({ myLocations, isLoading, error }) => ({
    myLocations,
    isLoading,
    error
  })
)
